export const codesSecteurContact = [
    'aviation',
    'defense',
    'sante',
    'maritime',
    'enseignement-recherche',
    'social',
];
export const estCodeSecteurContact = (codeSecteur) => {
    return codesSecteurContact.includes(codeSecteur);
};
